import {expressApi} from '@/api/axiosClients';

export async function getNode(nodeId, params) {
  try {
    const result = await expressApi.get(`/v1/nodes/${nodeId}`, {params});
    if (!result.status || result.status !== 200) {
      console.error('Server Error');
      return;
    }
    if (result.data.error) {
      console.error(result.data.message || 'Unknown Error');
      return;
    }
    return result.data;
  } catch (e) {
    console.error(e);
  }
}

export async function getHomeNodes(params) {
  try {
    const result = await expressApi.get(`/v1/home/nodes`, {params});
    if (!result.status || result.status !== 200) {
      console.error('Server Error');
      return;
    }
    if (result.data.error) {
      console.error(result.data.message || 'Unknown Error');
      return;
    }
    return result.data.nodes;
  } catch (e) {
    console.error(e);
  }
}
